<template>
	<nav class="navbar navbar-vertical navbar-expand-lg">
	    <div id="navbarVerticalCollapse" class="collapse navbar-collapse">
	        <div class="navbar-vertical-content">
	        	<ul id="navbarVerticalNav" class="navbar-nav flex-column">

	                <div class="nav-item-wrapper">
					    <router-link 
					    	class="nav-link label-1" 
					    	:to="{name: 'Home'}" 
					    	:class="{'active': ['Home'].includes(this.$route.name)}">
					        <div class="d-flex align-items-center">
					            <span class="nav-link-icon"><span class="fa-regular fa-house text-700 fs--1 form-icon"></span></span>
					            <span class="nav-link-text-wrapper"><span class="nav-link-text">Главная</span></span>
					        </div>
					    </router-link>

					    <hr/>
					</div>


					<li class="nav-item">
	                    <div class="nav-item-wrapper">
	                        <a 
	                        	:aria-expanded="this.$route.name.includes('Tinkoff') && !this.$route.name.includes('TinkoffNew') ? 'true' : 'false'" 
	                        	role="button" 
	                        	class="nav-link dropdown-indicator label-1">
	                            <div class="d-flex align-items-center">
	                                <div class="dropdown-indicator-icon"><span class="fa fa-caret-right"></span></div>
	                                <span class="nav-link-icon"><span class="fa-regular fa-building-columns text-700 fs--1 form-icon"></span></span>
	                                <span class="nav-link-text">
	                                	Tinkoff
	                                </span>
	                            </div>
	                        </a>
	                        <div class="parent-wrapper label-1">
	                            <ul class="nav collapse parent" :class="{'show': this.$route.name.includes('Tinkoff') && !this.$route.name.includes('TinkoffNew')}">
	                            	<li class="collapsed-nav-item-title d-none">
	                            		Tinkoff
	                            	</li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TinkoffHome'}"
	                                    	:class="{'active': ['TinkoffHome'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Главная</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TinkoffCard'}"
	                                    	:class="{'active': ['TinkoffCard'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Карта</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TinkoffHistory'}"
	                                    	:class="{'active': ['TinkoffHistory'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Транзакции</span></div>
	                                    </router-link >
	                                </li>
	                            </ul>
	                        </div>
	                    </div>
	                </li>


					<li class="nav-item">
	                    <div class="nav-item-wrapper">
	                        <a 
	                        	:aria-expanded="this.$route.name.includes('TinkoffNew') ? 'true' : 'false'" 
	                        	role="button" 
	                        	class="nav-link dropdown-indicator label-1">
	                            <div class="d-flex align-items-center">
	                                <div class="dropdown-indicator-icon"><span class="fa fa-caret-right"></span></div>
	                                <span class="nav-link-icon"><span class="fa-regular fa-building-columns text-700 fs--1 form-icon"></span></span>
	                                <span class="nav-link-text">
	                                	Tinkoff New
	                                </span>
	                            </div>
	                        </a>
	                        <div class="parent-wrapper label-1">
	                            <ul class="nav collapse parent" :class="{'show': this.$route.name.includes('TinkoffNew')}">
	                            	<li class="collapsed-nav-item-title d-none">
	                            		Tinkoff New
	                            	</li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TinkoffNewHome'}"
	                                    	:class="{'active': ['TinkoffNewHome'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Главная</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TinkoffNewCard'}"
	                                    	:class="{'active': ['TinkoffNewCard'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Карта</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TinkoffNewHistory'}"
	                                    	:class="{'active': ['TinkoffNewHistory'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Транзакции</span></div>
	                                    </router-link >
	                                </li>
	                            </ul>
	                        </div>
	                    </div>
	                </li>

	                <li class="nav-item">
	                    <div class="nav-item-wrapper">
	                        <a 
	                        	:aria-expanded="this.$route.name.includes('TrustWallet') ? 'true' : 'false'" 
	                        	role="button" 
	                        	class="nav-link dropdown-indicator label-1">
	                            <div class="d-flex align-items-center">
	                                <div class="dropdown-indicator-icon"><span class="fa fa-caret-right"></span></div>
	                                <span class="nav-link-icon"><span class="fa-regular fa-building-columns text-700 fs--1 form-icon"></span></span>
	                                <span class="nav-link-text">
	                                	Trust Wallet
	                                </span>
	                            </div>
	                        </a>

	                        <div class="parent-wrapper label-1">
	                            <ul class="nav collapse parent" :class="{'show': this.$route.name.includes('TrustWallet')}">
	                            	<li class="collapsed-nav-item-title d-none">
	                            		Trust Wallet
	                            	</li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TrustWalletHome'}"
	                                    	:class="{'active': ['TrustWalletHome'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Главная</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'TrustWalletTransactions'}"
	                                    	:class="{'active': ['TrustWalletTransactions'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Транзакции</span></div>
	                                    </router-link >
	                                </li>
	                            </ul>
	                        </div>
	                    </div>
	                </li>

					<li class="nav-item">
	                    <div class="nav-item-wrapper">
	                        <a 
	                        	:aria-expanded="this.$route.name.includes('Sberbank') ? 'true' : 'false'" 
	                        	role="button" 
	                        	class="nav-link dropdown-indicator label-1">
	                            <div class="d-flex align-items-center">
	                                <div class="dropdown-indicator-icon"><span class="fa fa-caret-right"></span></div>
	                                <span class="nav-link-icon"><span class="fa-regular fa-building-columns text-700 fs--1 form-icon"></span></span>
	                                <span class="nav-link-text">
	                                	Sberbank
	                                </span>
	                            </div>
	                        </a>

	                        <div class="parent-wrapper label-1">
	                            <ul class="nav collapse parent" :class="{'show': this.$route.name.includes('Sberbank')}">
	                            	<li class="collapsed-nav-item-title d-none">
	                            		Sberbank
	                            	</li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'SberbankHome'}"
	                                    	:class="{'active': ['SberbankHome'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Главная</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'SberbankTransactions'}"
	                                    	:class="{'active': ['SberbankTransactions'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Транзакции</span></div>
	                                    </router-link >
	                                </li>
	                            </ul>
	                        </div>
	                    </div>
	                </li>


					<li class="nav-item">
	                    <div class="nav-item-wrapper">
	                        <a 
	                        	:aria-expanded="this.$route.name.includes('Freedom') ? 'true' : 'false'" 
	                        	role="button" 
	                        	class="nav-link dropdown-indicator label-1">
	                            <div class="d-flex align-items-center">
	                                <div class="dropdown-indicator-icon"><span class="fa fa-caret-right"></span></div>
	                                <span class="nav-link-icon"><span class="fa-regular fa-building-columns text-700 fs--1 form-icon"></span></span>
	                                <span class="nav-link-text">
	                                	Freedom
	                                </span>
	                            </div>
	                        </a>

	                        <div class="parent-wrapper label-1">
	                            <ul class="nav collapse parent" :class="{'show': this.$route.name.includes('Freedom')}">
	                            	<li class="collapsed-nav-item-title d-none">
	                            		Freedom
	                            	</li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'FreedomHome'}"
	                                    	:class="{'active': ['FreedomHome'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Главная</span></div>
	                                    </router-link >
	                                </li>
	                                <li class="nav-item">
	                                    <router-link  
	                                    	class="nav-link"
	                                    	:to="{name: 'FreedomTransactions'}"
	                                    	:class="{'active': ['FreedomTransactions'].includes(this.$route.name)}">
	                                        <div class="d-flex align-items-center"><span class="nav-link-text">Транзакции</span></div>
	                                    </router-link>
	                                </li>
	                            </ul>
	                        </div>
	                    </div>
	                </li>

	                <div class="nav-item-wrapper">
	                	<hr/>

					    <a class="nav-link label-1" @click="logout">
					        <div class="d-flex align-items-center">
					            <span class="nav-link-icon"><span class="fa-regular fa-right-from-bracket text-700 fs--1 form-icon"></span></span>
					            <span class="nav-link-text-wrapper"><span class="nav-link-text">Выход</span></span>
					        </div>
					    </a>
					</div>

	            </ul>
	        </div>
	    </div>
	    <div class="navbar-vertical-footer">
	        <button class="btn navbar-vertical-toggle border-0 fw-semi-bold w-100 text-start white-space-nowrap">
	            <span class="fa-regular fa-arrow-left-long-to-line text-700 fs--1 form-icon"></span>
	            <span class="fa-regular fa-arrow-right-long-to-line text-700 fs--1 form-icon"></span>
	            <span class="navbar-vertical-footer-text ms-2">Свернутый вид</span>
	        </button>
	    </div>
	</nav>
</template>

<script>
export default {
	data () {
        return {
        	
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('token')
                            
            this.$axios.defaults.headers.common.Authorization = null

            this.$store.state.user.auth = false
        }
    },
    mounted () {

    	let nav_links = document.querySelectorAll('.nav-link')
    	for (var el of nav_links) {
	    	el.addEventListener('click', function(e){
	    		let aria_expanded_val = this.getAttribute('aria-expanded')
	    		if(aria_expanded_val == 'true') {
	    			this.setAttribute('aria-expanded', false)
	    		} else {
	    			this.setAttribute('aria-expanded', true)
	    		}
	    		this.classList.toggle('collapsed')
	    		if(this.nextSibling) {
	    			if(this.nextSibling.querySelector('ul.nav')) {
	    				this.nextSibling.querySelector('ul.nav').classList.toggle('show')
	    			}
	    		}
	    	})
    	}

    	document.querySelector('.navbar-vertical-toggle').addEventListener('click', function(e){
    		document.documentElement.classList.toggle('navbar-vertical-collapsed')
    	})
    }
}
</script>